import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  LoggedInUser,
} from './coPilotComplianceCheck';

export const CoPilotComplianceCheckExtension: any = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'coPilotComplianceCheck',
    component: LoggedInUser,
  }),
);
